// extracted by mini-css-extract-plugin
export var chevronIcon = "_6p-2";
export var teamName = "_6p-1";
export var teamSwitcherButton = "_6p-0";